import { Link } from "react-router-dom";

const partners = [
  { name: "Publishers", icon: "ri-book-open-line", type: "Publisher" },
  { name: "Wholesalers", icon: "ri-store-2-line", type: "Wholesaler" },
  { name: "Distributors", icon: "ri-truck-line", type: "Distributor" },
  { name: "Brand Owners", icon: "ri-award-line", type: "Brand Owner" },
  { name: "Manufacturers", icon: "ri-building-2-line", type: "Manufacturer" },
];

export default function Principles() {
  return (
    <section className="py-24 lg:py-32 bg-gray-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="text-xs font-medium text-akten tracking-widest uppercase mb-6">
            B2B PARTNERSHIP
          </p>
          <h2 className="text-4xl lg:text-5xl font-serif text-white leading-tight max-w-4xl mx-auto mb-6">
            Partner with AKTEN INC
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto mb-4">
            We invite authorized publishers, wholesalers, distributors, brand owners, and manufacturers to explore partnership opportunities with us.
          </p>
          <p className="text-sm text-white/50 max-w-xl mx-auto">
            AKTEN INC works exclusively with authorized supply chains. We carefully review all partnership requests and respond to qualified suppliers.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-16">
          {partners.map((partner, index) => (
            <Link
              key={index}
              to={`/partnership?type=${encodeURIComponent(partner.type)}`}
              className="bg-gray-900 rounded-2xl p-6 flex flex-col items-center justify-center text-center hover:bg-gray-800 transition-colors cursor-pointer"
            >
              <div className="w-14 h-14 rounded-full border-2 border-akten/30 bg-akten/10 flex items-center justify-center mb-4">
                <i className={`${partner.icon} text-akten text-2xl`}></i>
              </div>
              <span className="text-white font-medium text-sm">{partner.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
